import axios from 'axios'

const API_HOST = 'https://oncrypto.herokuapp.com/'
// const API_HOST = 'http://192.168.1.33:5000/'

export default {
    state: {
    },
    mutations: {
    },

    actions: {
        async getKlines({}, { exchange, symbol, ticker, pair, interval }) {
            const data = await axios.get(API_HOST + 'ticker', {
                params: { exchange, symbol, ticker, pair, interval }
            })
                .then(response => {
                    return response.data.data
                }).catch(error => {
                    return error
                })
              return data
        },

    }
}